import React from "react";
import monitor from "../../../assests/HPE/zerto/icon-backup.svg";
import protection from "../../../assests/HPE/zerto/icon-data.svg";
import ransomware from "../../../assests/HPE/zerto/icon-ransomware.svg";
import recovery from "../../../assests/HPE/zerto/icon-recovery.svg";
import FeatureCard from "../homepage/FeatureCard";

export const FeatureSectionZerto = ({ className }) => {
  return (
    <section
      className={`${className} flex-col gap-[64px] w-full lg:max-w-[522px] mb-24`}
    >
      <div className="flex flex-col gap-2">
        <p className="text-purple-06 b5 !font-semibold">
          HPE ZERTO SOFTWARE
        </p>
        <h4 className="text-grey-07 !text-[16px] md:!text-[18px]">
          One platform. Three critical protections.
        </h4>
        <p className="b3 text-grey-05">
         HPE Zerto replaces the traditional approach of siloed DR, backup, and ransomware tools with a single, 
         continuous data protection platform — eliminating the gaps attackers exploit and the complexity that slows recovery.
        </p>
      </div>

      <div className="flex flex-col gap-4">
        {/* <div className="flex flex-col gap-2">
                          <h3 className="text-black">Technical Proof Points for Production AI</h3>
                          <p className="b3 text-grey-05">To convince your team that this is more than just a cost-saving measure, consider these performance and operational benchmarks:</p>
                        </div> */}

        <div className="flex flex-col gap-6">
          <FeatureCard
            image={protection}
            title="Continuous Data Protection"
            // subtitle="From virtualisation to full-stack automation"
            description="Journal-based replication captures every write to disk — giving you thousands of recovery points per day and the ability 
            to roll back to any second before an incident, not just the last scheduled snapshot."
          />

          <FeatureCard
            image={ransomware}
            title="Real-Time Ransomware Detection"
            // subtitle="Control the chaos with autonomous IT operations"
            description="Zerto monitors encryption patterns in real time and alerts you the moment anomalous activity begins — enabling immediate, 
            surgical rollback to a clean recovery point before attackers can spread laterally."
          />

          <FeatureCard
            image={recovery}
            title="Disaster Recovery"
            // subtitle="Less data loss, less downtime always"
            description="Orchestrate failover across on-premises, private cloud, and public cloud (AWS, Azure) with near-zero RPO and RTO measured in seconds.
             Non-disruptive testing means you can validate your DR plan without business disruption."
          />

          <FeatureCard
            image={monitor}
            title="Backup & Long-Term Retention"
            // subtitle="Break free from hypervisor lock-in"
            description="Extend continuous protection into long-term retention for compliance, audit, and operational backup use cases —
             all from the same platform, without adding a separate backup solution or management overhead."
          />
        </div>
      </div>
    </section>
  );
};
